import './styles.scss'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { popupIcon } from 'Assets/Icons'
import { commonMethods } from 'Utils/commonMethods'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'

const TotalCertifiedMobileView = (props) => {
  const { t } = useTranslation()
  const { fetchedData, transformData, selectedMarket } = props
  const { dateFormatBasedOnUser, checkForUserAccess } = commonMethods

  const location = useLocation()
  const fullPath = location.pathname
  const pathSegments = fullPath.split('/')
  const desiredPath = pathSegments[2] || ''
  const userDetails = getLocalUserDetails()
  let menuLock

  if (userDetails && userDetails.menus) {
    const menu = userDetails.menus.find(({ menuUrl }) => menuUrl === desiredPath)

    if (menu) {
      menuLock = menu.menulock
    }
  }

  const [expandedRow, setExpandedRow] = useState(null)
  const [expandedRowArabica, setExpandedRowArabica] = useState(null)

  const handleRowExpandData = (index) => {
    setExpandedRow(expandedRow === index ? null : index)
  }

  const handleRowExpandDataArabica = (index) => {
    setExpandedRowArabica(expandedRowArabica === index ? null : index)
  }

  return (
    <div className="total-certified-mobile-view-container" data-testid="total-certified-mobile-view-container">
      <table>
        <thead>
          <tr>
            <th>{t('REPORT_DATE')}</th>
            <th>{t('CERTIFIED_STOCKS')}</th>
            <th>{t('COMPARE_TO_PRE_DAY')}</th>
          </tr>
        </thead>
        <tbody style={checkForUserAccess(menuLock)}>
          {selectedMarket === 'Robusta' && (
            <>
              {transformData(fetchedData)?.map((element, index) => {
                const { date, compareToPreviousDayColor, formattedCertifiedStocks, formattedComparisonToPreviousDay, formattedNonTenderable, formattedSuspended } = element

                return (
                  <React.Fragment key={index}>
                    <tr>
                      <td className="date-td">
                        {dateFormatBasedOnUser(date)}
                        <div className="icon-wrapper" data-testid="total-icon-container" onClick={() => handleRowExpandData(index)} style={{ cursor: 'pointer' }}>
                          <img src={popupIcon} alt="icon" className="popup-icon" title="Expand Row" />
                        </div>
                      </td>
                      <td className={compareToPreviousDayColor}>{formattedCertifiedStocks}</td>
                      <td className={compareToPreviousDayColor}>{formattedComparisonToPreviousDay}</td>
                    </tr>

                    {expandedRow === index && (
                      <tr className="expanded-row">
                        <td colSpan="3">
                          <div className="spreading-data-div">
                            <table>
                              <tr className="expanded-row-tr">
                                <th>{t('NON_TENDERABLE')}</th>
                              </tr>

                              <tr className="expanded-row-tr-td">
                                <td>{formattedNonTenderable}</td>
                              </tr>
                              <tr className="expanded-row-tr">
                                <th>{t('SUSPENDED_TITLE_CASE')}</th>
                              </tr>
                              <tr className="expanded-row-tr-td">
                                <td>{formattedSuspended}</td>
                              </tr>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                )
              })}
            </>
          )}
          {selectedMarket === 'Arabica' && (
            <>
              {transformData(fetchedData)?.map((element, index) => {
                const { Date, compareToPreviousDayColor, formattedCertifiedStocks, formattedComparisonToPreviousDay, formattedPendingGradingReport, formattedGrading, certifiedStockColor } = element

                return (
                  <React.Fragment key={index}>
                    <tr>
                      <td className="date-td">
                        {dateFormatBasedOnUser(Date)}
                        <div className="icon-wrapper" data-testid="total-icon-container" onClick={() => handleRowExpandDataArabica(index)} style={{ cursor: 'pointer' }}>
                          <img src={popupIcon} alt="icon" className="popup-icon" title="Expand Row" />
                        </div>
                      </td>
                      <td className={certifiedStockColor}>{formattedCertifiedStocks}</td>
                      <td className={compareToPreviousDayColor}>{formattedComparisonToPreviousDay}</td>
                    </tr>

                    {expandedRowArabica === index && (
                      <tr className="expanded-row">
                        <td colSpan="3">
                          <div className="spreading-data-div">
                            <table>
                              <tr className="expanded-row-tr">
                                <th>{t('PENDING_GRADING_TITLE_CASE')}</th>
                              </tr>

                              <tr className="expanded-row-tr-td">
                                <td>{formattedPendingGradingReport}</td>
                              </tr>
                              <tr className="expanded-row-tr">
                                <th>{t('DAILY_GRADING_SUMMARY')}</th>
                              </tr>
                              <tr className="expanded-row-tr-td">
                                <td>{formattedGrading}</td>
                              </tr>
                            </table>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                )
              })}
            </>
          )}
        </tbody>
      </table>
    </div>
  )
}

export default TotalCertifiedMobileView
